import bangkok01 from '../assets/home_carousel/bangkok-01.png';
import bangkok02 from '../assets/home_carousel/bangkok-02.png';
import bangkok03 from '../assets/home_carousel/bangkok-03.png';
import bangkok04 from '../assets/home_carousel/bangkok-04.png';
import bangkok05 from '../assets/home_carousel/bangkok-05.png';
import bangkok06 from '../assets/home_carousel/bangkok-06.png';
import bangkok07 from '../assets/home_carousel/bangkok-07.png';
import bangkok08 from '../assets/home_carousel/bangkok-08.png';
import bangkok09 from '../assets/home_carousel/bangkok-09.png';
import bangkok10 from '../assets/home_carousel/bangkok-10.png';

export const GRID_PREVIEW_COUNT = 9;

const GRID_IMAGES = [
  {
    src: bangkok01,
    alt: 'Wat Arun Temple at sunset',
    caption: 'Wat Arun at sunset.',
    position: 'center 30%',
  },
  {
    src: bangkok02,
    alt: 'A Tuk Tuk at night',
    caption: 'Tuk Tuk life! 🇹🇭',
    position: 'center 20%',
  },
  {
    src: bangkok03,
    alt: 'A beachside restaurant in Bang Saen',
    caption: 'A little weekend getaway to Bang Saen.',
    position: '70% 40%',
  },
  {
    src: bangkok04,
    alt: 'Dinar having his photo taken',
    caption: 'And sometimes…a photoshoot breaks out.',
    position: '30% 60%',
  },
  {
    src: bangkok05,
    alt: 'An Old Fashion cocktail at a bar',
    caption: 'An Old Fashion at the local watering hole.',
    position: 'center bottom',
  },
  {
    src: bangkok06,
    alt: "Chinese New Year's decorations",
    caption: 'Bangkok celebrates aaaaall the holidays!',
    position: '80% 25%',
  },
  {
    src: bangkok07,
    alt: 'Traditional Thai lunch',
    caption: 'Lunchbreak at the good old immigration office.',
    position: '20% 50%',
  },
  {
    src: bangkok08,
    alt: 'Bangkok skyline at sunset',
    caption: 'The peace of the concrete jungle.',
    position: 'center 70%',
  },
  {
    src: bangkok09,
    alt: 'An art exhibit of giant mirrored eggs',
    caption: 'Bangkok oozing culture at ever turn. ',
    position: '60% 35%',
  },
  {
    src: bangkok10,
    alt: 'Inside of dimly lit restaurant-bar in Bangkok',
    caption: 'One of my favorite spots. I think we\'re gonna need a bigger glass.',
    position: 'center',
  },
];

export default GRID_IMAGES;
